module.exports = __webpack_public_path__ + "64ed96cf69b1171d93807f6e678c1fed.png";